import React, {Fragment, useEffect, useState} from "react";
import {BlueButton} from "../../../component/button";
import Api from '../../../interface/api/visit-extends';
import {FileInfo} from "../../../interface/model/file";
import {
    CertificateInfo,
    constructCertificateInfo,
} from "../../../interface/model/visitorExtends";
import {VisitorInfo} from "../../../interface/model/visitor";
import FileApi from "../../../interface/api/file";

const ButtonStyle = {
    display: 'inline-block',
    height: '33px',
    padding: '0 15px',
    fontSize: '13px',
    lineHeight: '33px',
    verticalAlign: 'middle',
    cursor: 'pointer',
    border: 'none',
    borderRadius: '5px',
    color:'#fff',
    background: '#3280ff'
}
const ButtonStyle_ = {
    display: 'inline-block',
    height: '33px',
    padding: '0 10px',
    marginLeft: '5px',
    fontSize: '13px',
    lineHeight: '33px',
    verticalAlign: 'middle',
    cursor: 'pointer',
    border: 'none',
    borderRadius: '5px',
    color:'#fff',
    background: '#3280ff'
}

interface CertificateComponentInfo {
    visitorInfo : VisitorInfo,
    certificateCompleteHandler : (certificate:Array<CertificateInfo>) => void
}

export function CertificateInfoComponent({certificateInfoData, onClickHandler}) {
    const [ modal, setModal ] = useState<boolean>(false);

    return (
        <>
            <BlueButton type={'button'}
                        innerHTML={certificateInfoData!==undefined && certificateInfoData!==null ? '수정' : '등록'}
                        onClickHandler={() => setModal(true)}
            />
            {
                modal &&
                <Modal
                    certificateInfoData={certificateInfoData}
                    submitHandler={onClickHandler}
                    closeModal={setModal} />
            }
        </>
    )
}

export function CertificateComponent({visitorInfo, certificateCompleteHandler} : CertificateComponentInfo) {
    const [ certificateInfo, setCertificateInfo ] = useState<CertificateInfo>({...constructCertificateInfo, visitorInfoSeq:String(visitorInfo.seq)});
    const [ fileInfo, setFileInfo ] = useState<FileInfo>(null);

    function submit() {
        if( certificateInfo.fileInfos !== undefined ) {
            Api.createVisitorCertificate(certificateInfo)
                .then(res => {certificateCompleteHandler(res.data)})
        } else certificateCompleteHandler(null)
    }

    function onChangeHandler(e) {
        const {name, value, checked} = e.target;
        switch (name) {
            case 'certificateDate' :
                setCertificateInfo({...certificateInfo, certificateDate:value});
                break;
            default :
                break;
        }
    }

    function fileOnChange (e) {
        let fileArray = new Array();
        let files = e.target.files;
        for (let i = 0; i < files.length; i++) {
            if(files[i].size <= 10485760) {
                fileArray.push(files[i]);
            } else {
                alert('10MB 이하의 파일만 업로드 가능합니다.');
                throw 'fileMaxSizeError';
            }
        }

        FileApi.createFileInfo('CERTIFICATE', fileArray).then(res => {
            setFileInfo(res.data)
            setCertificateInfo({...certificateInfo, fileInfos:res.data});
        });
    }

    function deleteFile() {
        FileApi.deleteFileInfo(fileInfo.seq).then(res => {
            setFileInfo(null);
        });
    }

    useEffect(() => {
        if(certificateInfo!==undefined && certificateInfo!==null) {
            setFileInfo(certificateInfo.fileInfos[0]);
        }
    }, [])

    return (
        <section className="on">
            <div className="nv_tablebox">
                <div className="nv_table_tit">
                    <h2>유해화학물질 교육 수료증 등록</h2>
                    <a href={"https://edunics.me.go.kr/academy/intro.do"} className="blueBtn" target={"_blank"} style={{lineHeight: '45px'}}>유해화학물질 교육사이트</a>
                </div>
                <table className="nv_table">
                    <colgroup>
                        <col style={{width: '15%'}} />
                        <col style={{width: '35%'}} />
                        <col style={{width: '15%'}} />
                        <col style={{width: '35%'}} />
                    </colgroup>
                    <tr>
                        <td className="gray textcenter">첨부파일</td>
                        {
                            fileInfo == null ?
                                <td>
                                    <input type="file"
                                           id="insertFile"
                                           style={{display:"none"}}
                                           onChange={fileOnChange}
                                           required={true}
                                           multiple />
                                    <label htmlFor="insertFile" className="blueBtn">
                                        파일선택
                                    </label>
                                </td> :
                                <td>
                                    {fileInfo.fileName}
                                    <button type="button"
                                            className="minus"
                                            onClick={deleteFile}>삭제</button>
                                </td>
                        }
                        <td className="gray textcenter">수료일자</td>
                        <td>
                            <input type="text"
                                   className="nv_input"
                                   name="certificateDate"
                                   placeholder="수료일자(YYYYMMDD)"
                                   value={certificateInfo.certificateDate}
                                   onChange={onChangeHandler} />
                        </td>
                    </tr>
                </table>
            </div>
            <div className="nv_btn_area">
                {/*<button type="button" className="nv_btn_black">비동의</button>*/}
                <button type="button" className="nv_btn_blue" onClick={submit}>다음단계</button>
            </div>
        </section>
    )
}

function Modal({certificateInfoData, submitHandler, closeModal}) {
    const [ certificateInfo, setCertificateInfo ] = useState(certificateInfoData == undefined ? constructCertificateInfo : certificateInfoData);

    function submit(e) {
        e.preventDefault();
        if(certificateInfo.fileInfos===null)
            alert('파일을 선택해주세요.')
        else {
            submitHandler(certificateInfo);
            closeModal(false);
        }
    }

    function fileOnChange (e) {
        let fileArray = new Array();
        let files = e.target.files;
        for (let i = 0; i < files.length; i++) {
            if(files[i].size <= 10485760) {
                fileArray.push(files[i]);
            } else {
                alert('10MB 이하의 파일만 업로드 가능합니다.');
                throw 'fileMaxSizeError';
            }
        }
        FileApi.createFileInfo('CERTIFICATE', fileArray).then(
            res => setCertificateInfo({...certificateInfo, fileInfos: [res.data]})
        );
    }

    function deleteFile() {
        FileApi.deleteFileInfo(certificateInfo.fileInfos[0].seq).then(res => {
            setCertificateInfo({...certificateInfo, fileInfos: null});
            submitHandler(null);
        });
    }

    return (
        <div className="nv_modal nv_modal1 on">
            <div className="nv_modal_container">
                <div className="nv_modal_header">
                    <h2 id="find-host-title">유해화학물질 교육 수료증 첨부</h2>
                    <a
                        href={"https://edunics.me.go.kr/academy/intro.do"}
                        target={"_blank"}
                        style={ButtonStyle_}>유해화학물질 교육사이트</a>
                    <p className="nv_modal_close" onClick={() => closeModal(false)}>닫기</p>
                </div>
                <form onSubmit={submit}>
                    <div className="nv_modal_contents" style={{padding:'5px 15px'}}>
                        <table className="nv_table textcenter" style={{minWidth:0}}>
                            <colgroup>
                                <col width={'45%'}/>
                                <col width={'15%'}/>
                                <col width={'40%'}/>
                            </colgroup>
                            <thead>
                            <tr>
                                <th scope="row">첨부파일</th>
                                <th scope="row">관리</th>
                                <th scope="row">수료일자</th>
                            </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    {
                                        certificateInfo.fileInfos == null || certificateInfo.fileInfos.length == 0 ?
                                        <>
                                            <td>
                                            </td>
                                            <td>
                                                <input type="file"
                                                       id="insertFile"
                                                       style={{display: "none"}}
                                                       onChange={fileOnChange}
                                                       required={true}
                                                       multiple/>
                                                <label htmlFor="insertFile" style={ButtonStyle}>
                                                    파일선택
                                                </label>
                                            </td>
                                        </> :
                                        <>
                                            <td>{certificateInfo.fileInfos[0].fileName}</td>
                                            <td>
                                                <button type="button"
                                                        className="nv_button_red minus"
                                                        onClick={deleteFile}>삭제
                                                </button>
                                            </td>
                                        </>
                                    }
                                    <td>
                                        <input type="number"
                                               className="nv_input"
                                               name="certificateDate"
                                               placeholder="수료일자(YYYYMMDD)"
                                               value={certificateInfoData == undefined ? null : certificateInfoData.certificateDate}
                                               onChange={(e) => (setCertificateInfo({...certificateInfo, certificateDate: e.target.value}))} />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <p style={{color:'red'}}>* 첨부파일은 10MB 이하의 파일만 등록이 가능합니다.</p>
                    </div>
                    <div className="nv_btn_area" style={{textAlign: 'center', margin:'10px 0px'}}>
                        <button type="submit" className="nv_btn_blue" style={{marginTop:0}}>저장</button>
                    </div>
                </form>
            </div>
        </div>
    )
}